import Auth from '../../Helpers/auth';
const API_URL = process.env.REACT_APP_BACKEND_URL;

// GET: Gets the users profile - protected route
async function httpGetUser(userId) {
  const token = Auth.getToken();
  try {
    let user = await fetch(`${API_URL}/users/actions/${userId}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
    return user.json();
  } catch (err) {
    return err;
  }
}

// GET: Gets the users certificate information - protected route
async function httpGetCertificateInfo(id, course) {
  const token = Auth.getToken();
  try {
    let user = await fetch(`${API_URL}/users/certs/${id}/${course}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
    return user.json();
  } catch (err) {
    return err;
  }
}
// GET: Purchase history for a user
async function httpGetPurchaseHistory(id) {
  const token = Auth.getToken();
  try {
    let history = await fetch(
      `${API_URL}/users/courses/purchase-history/${id}`,
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      }
    );
    return history.json();
  } catch (err) {
    return err;
  }
}

// GET: Gets the users cart - protected route
async function httpGetCart(id) {
  const token = Auth.getToken();
  try {
    let cart = await fetch(`${API_URL}/users/cart/${id}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
    return cart.json();
  } catch (err) {
    return err;
  }
}

// GET: Gets the users quiz results for a specific course - protected route
async function httpGetQuizResults(courseId, userId, userCourseId) {
  const token = Auth.getToken();
  try {
    const quizResultsPath = userCourseId
      ? `${API_URL}/users/courses/quiz-results/${courseId}/${userId}/${userCourseId}`
      : `${API_URL}/users/courses/quiz-results/${courseId}/${userId}`;

    let results = await fetch(quizResultsPath, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
    let data = await results.json();
    console.log('Quiz results response status:', data);
    return data?.result;
  } catch (err) {
    return err;
  }
}

// GET: Gets the users course information for a specific course - protected route
async function httpGetUserCourse(userId, userCourseId) {
  const token = Auth.getToken();

  try {
    let userCourse = await fetch(
      `${API_URL}/users/courses/user-course/${userId}/${userCourseId}`,
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      }
    );

    return userCourse.json();
  } catch (err) {
    return err;
  }
}

export {
  httpGetCertificateInfo,
  httpGetUser,
  httpGetPurchaseHistory,
  httpGetCart,
  httpGetQuizResults,
  httpGetUserCourse,
};
